/*
 * @Author: cc
 * @Date: 2020-02-12 08:35:37
 * @LastEditTime: 2022-01-27 10:13:25
 * @LastEditors: Please set LastEditors
 * @FilePath: \xjmediacloud\app\editingCenter\service\preview.js
 * @Description:
 */
'use strict';
angular.module('previewModule', []).factory('previewService', [
    '$modal',
    '$q',
    '$timeout',
    'trsHttpService',
    function ($modal, $q, $timeout, trsHttpService) {
        return {
            initIwoMethod: function () {
                var methodname = {
                    1: 'getNewsDoc',
                    2: 'getPicsDoc',
                    3: 'getNewsDoc',
                    4: 'getLinkDoc',
                    5: '',
                    6: '',
                    7: 'getVideoDoc',
                    8: 'getLiveDoc',
                };
                return methodname;
            },

            /**
             * [videoPlayer description] 音视频播放弹窗
             * @param   {[type]}  videoid   [videoid description]
             * @param   {[type]}  type      [type description]
             * @param   {[type]}  fileName  [fileName description]
             * @return  {[type]}            [return description]
             */
            videoPlayer: function (videoid, type, fileName) {
                $modal.open({
                    templateUrl: './editingCenter/iWo/iWoResource/personalMaterial/service/filePreview/filePreview_tpl.html',
                    windowClass: 'edit-iwo-personalMaterial-filePreview',
                    backdrop: false,
                    controller: 'editIwoPersonalMaterialFilePreviewCtrl',
                    resolve: {
                        item: function () {
                            return {
                                VIDEOID: videoid,
                                FILETYPE: type,
                                FILEDESC: fileName,
                            };
                        },
                    },
                });
            },

            /**
             * [getAudioVideoPlayer description] 获取音视频id
             * @param  {[type]} item [description]
             * @param  {[string]} type [description] 音视频类型
             * @return {[type]}      [description]
             */
            getAudioVideoPlayer: function (item, type) {
                var deffer = $q.defer();
                var zjVParams = {
                    serviceid: 'mlf_videoInterfacesEncapsulation',
                    methodname: 'getVideoUrl',
                    VideoId: item,
                    resourceType: type,
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), zjVParams, 'post').then(function (data) {
                    if (data.msg == '视频不存在' || !data) {
                        deffer.reject();
                    } else {
                        // var url = data.data.videoUrl;
                        deffer.resolve(data);
                    }
                });
                return deffer.promise;
            },
            getFusioninfo: function (id, index) {
                var deffer = $q.defer();
                var methodnameArr = this.initIwoMethod();
                var params = {
                    MetaDataId: id,
                    methodname: methodnameArr[index],
                    serviceid: 'mlf_myrelease',
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function (data) {
                    deffer.resolve(data);
                });
                return deffer.promise;
            },

            /**
             * [isEditor description] 给音视频图片添加标识
             * @param   {[boolean]}  isEditor    [isEditor description] 是否是编辑器
             * @param   {[boolean]}  reDraw      [isEditPage description]  重新渲染
             * @return  {[undefined]}            [return description]
             */
            drawVideoMark: function (isEditor, reDraw) {
                var videoImg;
                $timeout(() => {
                    if (isEditor) {
                        var iframe = document.getElementById("ueditor_0");
                        var iwindow = iframe.contentWindow;
                        var idoc = iwindow.document;
                        videoImg = idoc.getElementsByClassName('trsresize')
                    }
                    else {
                        videoImg = $('img.trsresize');
                    }
                    if (!videoImg.length) { return; } // 没有视频图片就退出
                    var img = new Image();
                    // var mediaType = 'video';
                    //  将图片画到canvas上面上去！
                    img.setAttribute('crossOrigin', 'anonymous');
                    img.onload = function () {
                        for (let i = 0; i < videoImg.length; i++) {
                            if (reDraw) { // 切换编辑器时去掉属性，重新画一遍
                                videoImg[i].removeAttribute('crossOrigin');
                            }
                            if (videoImg[i].getAttribute('crossOrigin') === 'anonymous') { // 插入编辑器时，考虑到有新增的，老的被打标的图片不再重新渲染
                                continue;
                            }
                            let image = new Image();
                            image.setAttribute('crossOrigin', 'anonymous');
                            image.onload = function () {
                                let video = videoImg[i];
                                if (!video.getAttribute('videoid') || video.getAttribute('resourcetype') !== 'video') {
                                    return;
                                } // 没有videoid就表示不是视频，并且不是视频就退出
                                var canvas = document.createElement('canvas');
                                //  获取2d对象
                                var ctx = canvas.getContext('2d');
                                canvas.width = video.width;
                                //  视频无法渲染设定图片固定值
                                canvas.height = video.height;
                                ctx.fillRect(0, 0, canvas.width, canvas.height);
                                // 先截图当前的图
                                ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
                                var base64 = canvas.toDataURL('image/png');
                                video.src = base64;
                                try {
                                    var imgWH = 88;
                                    // 再给截图填上视频标记戳
                                    ctx.drawImage(img, canvas.width / 2 - (imgWH / 2), canvas.height / 2 - (imgWH / 2), imgWH, imgWH);
                                    //  获取base64的图片数据
                                    base64 = canvas.toDataURL('image/png');
                                    video.src = base64;
                                } catch { }
                            };
                            if (videoImg[i].src.includes('?')) {
                                let srcArr = videoImg[i].src.split('?');
                                image.src = srcArr[0] + '?time=' + new Date().valueOf() + '&' + srcArr[1] + '&';
                            } else {
                                image.src = videoImg[i].src + '?time=' + new Date().valueOf();
                            }
                            // image.src = videoImg[i].src + '?time=' + new Date().valueOf();
                        }
                    };
                    img.src = './images/videoMark.png';
                });
            },
        };
    },
]);
